"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var SwitchContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 50px;\n  height: 25px;\n  background-color: ", ";\n  border-radius: 25px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.2s;\n"], ["\n  display: inline-block;\n  width: 50px;\n  height: 25px;\n  background-color: ", ";\n  border-radius: 25px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.2s;\n"])), function (props) { return (props.checked ? "#4caf50" : "#ccc"); });
var SwitchHandle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 23px;\n  height: 23px;\n  border-radius: 50%;\n  position: absolute;\n  top: 1px;\n  left: ", ";\n  transition: left 0.2s;\n"], ["\n  width: 23px;\n  height: 23px;\n  border-radius: 50%;\n  position: absolute;\n  top: 1px;\n  left: ", ";\n  transition: left 0.2s;\n"])), function (props) { return (props.checked ? "26px" : "1px"); });
var Switch = function (_a) {
    var checked = _a.checked, onChange = _a.onChange;
    var handleToggle = function () {
        onChange(!checked);
    };
    return ((0, jsx_runtime_1.jsx)(SwitchContainer, __assign({ checked: checked, onClick: handleToggle, className: "twap-switch ".concat(checked ? "twap-switch-checked" : "") }, { children: (0, jsx_runtime_1.jsx)(SwitchHandle, { checked: checked, className: "twap-switch-handle " }) })));
};
exports.Switch = Switch;
var templateObject_1, templateObject_2;
